import React from "react";
import { Plus, Check, Circle } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "@/components/ui/collapsible";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const methods = [{
  name: "Ausbau der Fahrtreppe",
  desc: "\n",
  advantage: "Effektiv, perfekte Reinigung - es ist sogar eine Neubeschichtung möglich.",
  disadvantage: "Zeitaufwändig und in den meisten Fällen nicht in einer einzigen Nacht zu erledigen. Hohe Kosten."
}, {
  name: "Trockenreinigung",
  desc: "\n",
  advantage: "\n",
  disadvantage: "Zerstört die Beschichtung, Treppe wird rutschiger, Staub und Öl werden nicht entfernt."
}, {
  name: "Reinigung mit CO - Strahler (Trockeneis)",
  desc: "\n",
  advantage: "Effektives Reinigungsverfahren.",
  disadvantage: "Die Absaugung des gelösten Schmutzes in der Luft ist meist nur unvollständi"
}, {
  name: "Reinigung mit Wasser (Reinigungsflüssigkeit) und Bürsten",
  desc: "\n",
  advantage: "Je nach Maschineneinsatz befriedigende bis gute Ergebnisse",
  disadvantage: "Viele Maschinen saugen die Reinigungsflüssigkeit nicht sofort und vollständig ab"
}];
export default function VerfahrenTechnik() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="verfahren-technik" ref={ref} className={cn("py-24 bg-background transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="mb-12 max-w-3xl">
          <h2 className="text-3xl font-bold tracking-tight text-primary mb-4">
            Überblick Reinigungsverfahren
          </h2>
          <p className="text-lg text-muted-foreground">Hier finden Sie verschiedenste Methoden im technischen Vergleich.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {methods.map((item, i) => <Collapsible key={i} data-index={i} className="group/collapsible h-full">
              <Card className="h-full border-l-4 border-l-accent shadow-sm hover:shadow-md transition-shadow duration-300 bg-card">
                <CardHeader className="pb-4">
                  <div className="flex items-start justify-between gap-4">
                    <CardTitle className="text-lg font-semibold text-foreground leading-snug">
                      {item.name}
                    </CardTitle>
                    <CollapsibleTrigger asChild>
                      <Button variant="ghost" size="icon" className="shrink-0 h-8 w-8 text-muted-foreground hover:text-primary hover:bg-secondary/50" aria-label="Details anzeigen">
                        <Plus className="h-5 w-5 transition-transform duration-300 group-data-[state=open]/collapsible:rotate-45" />
                      </Button>
                    </CollapsibleTrigger>
                  </div>
                  <CardDescription className="text-sm mt-2 font-medium text-muted-foreground/80">
                    {item.desc}
                  </CardDescription>
                </CardHeader>
                
                <CollapsibleContent>
                  <CardContent className="pt-0 pb-6">
                    <div className="space-y-4 border-t border-border/50 pt-4 mt-2">
                      {}
                      <div className="flex items-start gap-3">
                        <div className="mt-0.5 shrink-0 rounded-full bg-emerald-50/50 p-1 dark:bg-emerald-950/20">
                          <Check className="h-4 w-4 text-emerald-600" />
                        </div>
                        <div className="space-y-1">
                          <span className="text-xs font-mono uppercase tracking-wider text-muted-foreground">
                            Vorteil
                          </span>
                          <p className="text-sm text-foreground leading-relaxed">
                            {item.advantage}
                          </p>
                        </div>
                      </div>

                      {}
                      <div className="flex items-start gap-3">
                        <div className="mt-0.5 shrink-0 rounded-full bg-muted/50 p-1">
                          <Circle className="h-4 w-4 text-muted-foreground fill-muted-foreground/20" />
                        </div>
                        <div className="space-y-1">
                          <span className="text-xs font-mono uppercase tracking-wider text-muted-foreground">
                            Nachteil
                          </span>
                          <p className="text-sm text-foreground leading-relaxed">
                            {item.disadvantage}
                          </p>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </CollapsibleContent>
              </Card>
            </Collapsible>)}
        </div>
      </div>
    </section>;
}